window.FontAwesomeConfig = { autoReplaceSvg: false }
